import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import "./form-item-dfc-personal.component.scss";
var FormItemDfcPersonal = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemDfcPersonal, _super);
    function FormItemDfcPersonal(element) {
        var _this = _super.call(this, element) || this;
        _this.gRecaptchaToken = '';
        return _this;
    }
    FormItemDfcPersonal.prototype.init = function () {
        this.applyForm = this.element.querySelector("form");
        this.applyFormSubmit = Array.from(this.element.querySelectorAll(".js-apply-now__button"));
        this.applyFormRadio = Array.from(this.element.querySelectorAll(".js-identification_radio--group"));
        if (document.getElementById("apply-now-modal-form8e3b779e2ffaa710VgnVCM2000008811960aRCRD")) {
            this.closeButton = document
                .getElementById("apply-now-modal-form8e3b779e2ffaa710VgnVCM2000008811960aRCRD")
                .querySelector(".js-apply-now-modal-close");
        }
        else if (document.getElementById("apply-now-modal-form0bf44b5bcfb72810VgnVCM1000002c836d0aRCRD")) {
            this.closeButton = document
                .getElementById("apply-now-modal-form0bf44b5bcfb72810VgnVCM1000002c836d0aRCRD")
                .querySelector(".js-apply-now-modal-close");
        }
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharingGroupTextArea = this.element.querySelector(".data-sharing-group");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".data-sharing-3rd-party");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".data-sharing-boarders");
    };
    FormItemDfcPersonal.prototype.bindEvents = function () {
        var _this = this;
        if (document.getElementById("apply-now-modal-form8e3b779e2ffaa710VgnVCM2000008811960aRCRD") ||
            document.getElementById("apply-now-modal-form0bf44b5bcfb72810VgnVCM1000002c836d0aRCRD")) {
            this.closeButton.addEventListener("click", function (event) {
                return _this.closeModal();
            });
        }
        this.applyFormRadio.map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                var identificationField = _this.applyForm.querySelector("input[name=identification]");
                var identificationType = evt.value;
                if (identificationType === "said") {
                    identificationField.classList.remove("form__input--identification--passport");
                    identificationField.classList.add("form__input--identification");
                    identificationField.placeholder = "Enter you South Africa ID number";
                    identificationField.type = "number";
                }
                else {
                    identificationField.classList.remove("form__input--identification");
                    identificationField.classList.add("form__input--identification--passport");
                    identificationField.placeholder = "Enter you Passport number";
                    identificationField.type = "text";
                }
            });
        });
        this.applyFormSubmit.map(function (item) {
            return item.addEventListener("click", function (event) {
                var _button = event.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    // screens
                    var loader = _form.querySelector(".form__loader--container");
                    var fieldsContainer = _form.querySelector(".form__fields--container");
                    // loader + hide form
                    loader.classList.add("active");
                    fieldsContainer.classList.add("hidden");
                    // Check if gRecaptcha is enabled for this form
                    if (grecaptcha != null && _this.formsService.getGRecaptchaSiteKey() != '') {
                        var gToken_1 = '';
                        try {
                            // Attempt to get recaptcha token
                            grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var err_1;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                        case 1:
                                            gToken_1 = _a.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            err_1 = _a.sent();
                                            // Log error
                                            console.log("Unable to retrieve gRecaptcha Token");
                                            console.log(err_1);
                                            return [3 /*break*/, 3];
                                        case 3:
                                            // Set recaptcha token
                                            this.gRecaptchaToken = gToken_1;
                                            this.submitForm(_form);
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        catch (err) {
                            // Log error
                            console.log("Unable to retrieve gRecaptcha Token");
                            console.log(err);
                            _this.submitForm(_form);
                        }
                    }
                    else {
                        _this.submitForm(_form);
                    }
                }
            });
        });
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute("hidden", "true");
                _this.showMoreBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute("hidden", "true");
                _this.showLessBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.removeAttribute("hidden");
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
                _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
                _this.dataSharingGroupShowBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute("hidden");
                _this.dataSharingGroupHideBtn.removeAttribute("hidden");
                _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
                _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
                _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
                _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
                _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute("hidden");
                _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
                _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
                _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
                _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
            });
        }
        if (this.applyForm) {
            var _formFields = Array.from(this.applyForm.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    FormItemDfcPersonal.prototype.closeModal = function () {
        this.analyticsService.dtmFormAbandon();
    };
    FormItemDfcPersonal.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemDfcPersonal.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var error = form.querySelector(".form__error--container");
        // variabless
        var description = form.querySelector("input[name=description]");
        var firstname = form.querySelector("input[name=first-name]");
        var lastname = form.querySelector("input[name=last-name]");
        var contact = form.querySelector("input[name=phone-number]");
        var contact2 = form.querySelector("input[name=phone-number-2]");
        var idnumber = form.querySelector("input[name=identification]");
        var email = form.querySelector("input[name=emailAddress]");
        var popiaConsent = form.querySelector("input[name=popia-consent]");
        var _date = form.querySelector("input[name=date]");
        var _popiaConsent = form.querySelector("input[name=popia-consent]");
        var _time = form.querySelector("select[name=time]");
        var _dateTime = "anytime";
        if (_date && _time) {
            if (_time.value !== "Anytime") {
                _dateTime = _date.value + " " + _time.value;
            }
        }
        var _postData = {
            description: description ? description.value : "",
            fullName: firstname && lastname
                ? firstname.value + " " + lastname.value
                : firstname
                    ? firstname.value
                    : "",
            contact: contact ? contact.value : "",
            contact2: contact2 ? contact2.value : "",
            idNum: idnumber ? idnumber.value : "",
            email: email ? email.value : "",
            timeToCall: _dateTime,
            popiConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            source: this.formsService.isMobile(),
            dataPrivacyConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-group"),
            dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(form, "data-sharing-3rd-party"),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-boarders"),
            recaptchaToken: this.gRecaptchaToken
        };
        // service
        var url = this.baseUrl + "/services/SubmitApplicationFormV1.jsp";
        this.formsService
            .postForm(url, this.http.serialiseObject(_postData))
            .then(function (response) {
            // service ok
            if (!response.data || String(response.data).match(/invalid/gi) || String(response.data).match(/503/gi)) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                loader.classList.remove("active");
                if (error) {
                    error.classList.add("active");
                }
                else {
                    thankYou.classList.add("active");
                }
            }
            else if (response.data.captchaResponse != null && response.data.captchaResponse == false) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                loader.classList.remove("active");
                if (error) {
                    error.classList.add("active");
                }
                else {
                    thankYou.classList.add("active");
                }
            }
            else {
                _this.analyticsService.dtmFormComplete("complete", response.data, false, "", email.value, contact.value);
                loader.classList.remove("active");
                thankYou.classList.add("active");
            }
        })
            .catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            loader.classList.remove("active");
            if (error) {
                error.classList.add("active");
            }
            else {
                thankYou.classList.add("active");
            }
        });
    };
    return FormItemDfcPersonal;
}(Base));
export { FormItemDfcPersonal };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-dfc-personal/form-item-dfc-personal.component.ts
// module id = 897
// module chunks = 0